<p-drawer [visible]="visible()" (onHide)="onDrawerHide()" position="right"
    [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar w-full md:w-1/3!"
    header="Switch Course">
    <div class="flex flex-col mx-auto md:mx-0">
        <div class="w-full mb-6">
            <input type="text" class="w-full" (input)="onCourseFilter($event)" pInputText placeholder="Search by Name">
        </div>

        <ul class="list-none m-0 p-0 flex flex-col gap-3">
            @for(course of filteredCourses(); track course._id) {
            <li>
                <a class="relative flex items-center p-4 border rounded-xl transition-all duration-200"
                    [ngClass]="currentCourseIdComputed() === course._id
                        ? 'bg-highlight border-primary-500 pointer-events-none'
                        : 'bg-[var(--p-content-background)] border-surface hover:bg-emphasis hover:border-surface cursor-pointer'"
                    (click)="onCourseSelect(course)">
                    
                    <div class="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                        [ngClass]="currentCourseIdComputed() === course._id ? 'bg-primary-100 text-primary-700' : 'bg-surface-100 dark:bg-surface-800 text-muted-color'">
                        <i class="fa-solid fa-golf-ball-tee text-lg"></i>
                    </div>

                    <div class="ml-4 flex-1">
                        <div class="flex items-center gap-2">
                            <span class="font-bold text-color">{{course.displayName}}</span>
                            @if(currentCourseIdComputed() === course._id) {
                                <p-tag value="Current" severity="info" [rounded]="true" styleClass="text-[10px] px-2 py-0 h-5"></p-tag>
                            }
                        </div>
                        <p class="text-sm text-muted-color m-0 mt-0.5">{{course.property?.display}}</p>
                    </div>

                    @if(currentCourseIdComputed() === course._id) {
                        <div class="absolute top-4 right-4 text-primary-600">
                            <i class="pi pi-check-circle text-xl"></i>
                        </div>
                    }
                </a>
            </li>
            }
        </ul>

    </div>
</p-drawer>